module.exports = __webpack_public_path__ + "static/img/code-news.c079d94.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/code-news.png
// module id = xBjz
// module chunks = 0